module.exports = __webpack_public_path__ + "img/MEGA_120X35.b644be62.png";